import { useAuth } from "../contexts/AuthContext";

export type MainTab = "kpi" | "rating";

/** Две вкладки снизу, закреплены как в CRM KPI (fixed, py-3, иконка text-xl): «KPI» (по умолчанию) и «Рейтинг». */
export function BottomNav({ tab, onChange }: { tab: MainTab; onChange: (t: MainTab) => void }) {
  const { t } = useAuth();
  const items: Array<{ key: MainTab; icon: string; label: string }> = [
    { key: "kpi", icon: "📊", label: t("nav_kpi") },
    { key: "rating", icon: "🏆", label: t("nav_rating") },
  ];
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 flex" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
      {items.map(it => {
        const active = it.key === tab;
        return (
          <button
            key={it.key}
            type="button"
            onClick={() => onChange(it.key)}
            aria-current={active ? "page" : undefined}
            className={`flex-1 py-3 flex flex-col items-center gap-0.5 ${active ? "text-teal-700" : "text-slate-400"}`}
          >
            <span className="text-xl">{it.icon}</span>
            <span className="text-[10px] font-medium">{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
